import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { openConsentPreferences } from '../utils/consent';
import { isEmbedConsentContext } from '../utils/consentUx';
import './Footer.css';

function Footer() {
  const location = useLocation();
  const isEmbed = isEmbedConsentContext(location);
  const notice = window.LVMTrackingNotice;
  const privacyState = location.pathname === '/checkout/success'
    ? { checkoutSessionId: new URLSearchParams(location.search).get('session_id')?.slice(0, 256) }
    : undefined;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img
              src="/logo.png"
              srcSet="/logo.png 1x, /logo@2x.png 2x, /logo@3x.png 3x"
              alt="LoveVibesMusic"
              width="311"
              height="72"
              className="footer-logo"
            />
            <p>Discover and book the best nightlife events in your city.</p>
          </div>
          <div className="footer-links">
            <h4>Events</h4>
            <Link to="/events">All Events</Link>
            <Link to="/events?category=rave">Raves</Link>
            <Link to="/events?category=party">Parties</Link>
          </div>
          <div className="footer-links">
            <h4>Support</h4>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/faq">FAQs</Link>
            <Link to={notice?.privacyUrl('/privacy') || '/privacy'} state={privacyState}>Privacy</Link>
            <Link to="/terms">Terms</Link>
            {notice?.enabled() ? (
              <Link to={notice.privacyUrl('/privacy')} state={privacyState} target={isEmbed ? '_top' : undefined}>Cookie settings</Link>
            ) : !isEmbed && (
              <button type="button" className="footer-cookie-settings" onClick={openConsentPreferences}>
                Cookie settings
              </button>
            )}
          </div>
          <div className="footer-links">
            <h4>For Organisers</h4>
            <Link to="/become-organiser">Sell Tickets</Link>
            <Link to="/embedded-ticketing">Embedded Ticketing</Link>
            <Link to="/admin">Dashboard</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} LoveVibesMusic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
